module.exports = __webpack_public_path__ + "img/inquiry.26911423.svg";